<template>
  <div>
    <div v-if="sortedEnterPricegroups.length">
      <div v-for="p in sortedEnterPricegroups" :key="`pricegroup-${p.id}`">
        <select-pricegroup-tickets-amount :pricegroup="p" :section="section"/>
      </div>
    </div>
    <div class="text-center mt-5" v-else>
      <div>
        {{ selectText }} <b>{{ transName(section.title) }}</b>
      </div>
      <div>{{ trans('price') }}: <b>{{ tickets[0].price | formatNumber }} ₸</b></div>
      <div class="text-center mt-3">
        <a class="plus-btn" :class="{ disabled: amount < 1 }" @click="changeAmount('-')">-</a>
        <span class="amount-span">{{ amount }}</span>
        <a class="minus-btn" :class="{ disabled: amount >= max }" @click="changeAmount('+')">+</a>
      </div>
      <div v-if="section.min_tickets > 1" class="mt-4 alert alert-warning">{{ trans('amount_of_tickets') }}: {{ section.min_tickets }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "SelectEnterSectionTicketsAmount",
  props: {
    tickets: {
      type: Array
    },
    section: {
      type: Object
    },
  },
  computed: {
    ...mapState([
      'cart',
      'ticketsLimit',
      'enterPricegroups',
      'event'
    ]),
    sortedEnterPricegroups() {
      return this.enterPricegroups.sort((a, b) => (b.pricegroup?.sort_order || 1) - (a.pricegroup?.sort_order || 1))
    },
    max() {
      return Math.min(this.tickets.length, this.adjustedTicketsLimit)
    },
    adjustedTicketsLimit() {
      return this.section.min_tickets ? this.section.min_tickets : this.ticketsLimit
    },
    amount() {
      return this.cart.reduce((a, v) => (v.section_id === this.section.id ? a + 1 : a), 0)
    },
    selectText() {
      if(this.section && this.transName(this.section.select_text)) return this.transName(this.section.select_text)
      if(this.event && this.transName(this.event.section_amount_text)) return this.transName(this.event.section_amount_text)
      return this.trans('choose_tickets_in_sector')
    }
  },
  methods: {
    changeAmount(sign) {
      if(sign === '+' && this.amount >= this.max) return
      if(sign === '-' && this.amount <= 0) return
      let ticket = {
        price: this.tickets[0].price,
        section_id: this.section.id
      }
      if(this.tickets[0].seat_id) ticket.seat_id = this.tickets[0].seat_id
      ticket.section_name = this.section.title
      let quantity = this.section.min_tickets ? this.section.min_tickets : 1
      ticket.min_tickets = quantity
      for(let i = 0; i < quantity; i++) {
        this.$store.commit('updateCart', { sign, ticket, ignoreGTag: false, ignoreLimit: quantity > 1 })
      }
    }
  }
}
</script>
